<template>
     <b-container class="p-0">
        <div v-if="IsEditor" 
            class="d-flex align-items-center my-auto pr-2 h5"> 
            <b-icon-gear 
                style="pointer-events: all; cursor: pointer;" />
                <!-- @click="changeParameter(fieldSet)" /> -->
        </div>
        <b-table-simple v-if="Parameter.Options.length > 0"
                        id="my-table" :ref="'Table'">
            <b-thead class="table-bordered text-center">
                <b-tr>
                    <b-th v-for="field in getFields(Parameter.Options)" :key="field.key">
                        <div v-if="field.key != 'Selected'">
                            {{ field.key }}
                        </div>
                        <div v-else>
                            <b-form-checkbox :checked="rowsChecked(Parameter.Options, Number(Parameter.Option), Number(Parameter.PageSize))"
                                 @change="selectRows($event, Parameter.Options, Number(Parameter.Option), Number(Parameter.PageSize))"
                                 class="text-left"
                                 plain />
                        </div>
                    </b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="items in getItems(Parameter.Options, Number(Parameter.Option), Number(Parameter.PageSize))"
                      :key="items.Key"
                      style="cursor: pointer;"
                      :class="getRowClass(items)"
                      @click="selectRow($event, Parameter.Options, items.Key)">
                    <b-td v-for="item in items.Value"
                            class="p-2 !important"
                            :key="items.Key + item.Key">
                        <div v-if="item.Key === 'Selected'">
                            <b-checkbox v-model="item.Value" plain />
                        </div>
                        <div v-else>
                            {{ item.Value }}
                        </div>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-row v-if="Parameter.Options.length > 0">
            <b-col cols="7">
                <b-pagination :ref="'Pagination'"
                   v-model="Parameter.Option"
                   :total-rows="Parameter.Options.length"
                   :per-page="Parameter.PageSize"
                   align="fill"
                   plain />
            </b-col>
            <b-col cols="5" class="d-flex justify-content-end align-self-center">
                <b-checkbox :checked="isChecked(Parameter.Options[0].Value)" @change="selectAll($event, Parameter.Options)" plain>{{ $t('SelectAll') }} <!--Sélectionner tout--></b-checkbox>
            </b-col>
        </b-row>

        <h6 v-if="Parameter.Options.length === 0" class="text-center">{{ $t('NoDataAvailable') }} <!--Aucune données disponible--></h6>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import GridPanelField from '../Class/GridPanelField';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class GridPanelItem extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop({default: () => false})
        public IsEditor!: boolean;

        @Prop()
        public Parameter!: GridPanelField;

        /**
         * Récupère les Entête du tableau
         * @param rows 
         */
        // private getFields(rows: {Key: string, Value: {Key: string, Value: string}[]}[]){
        private getFields(rows: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }>){
            let json: {key: string, sortable: boolean}[] = [];

            rows[0].Value.forEach(u => {
                if(u.Key == 'Selected')
                json.push({key: 'Selected', sortable: false});
            else
                json.push({key: this.$t(u.Key) as string, sortable: true});
            })

            return json;
        }

        /**
         * Récupère les lignes qui sont Checked
         * @param rows 
         * @param page 
         * @param pageSize 
         */
        private rowsChecked(rows: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }>, page: number, pageSize: number){
            let items: {Key: string, Value: {Key: string, Value: string}[]}[] = [];
            items = this.getItems(rows, page, pageSize);

            let isChecked: boolean = true;

            // Si une des lignes est décochée
            items.forEach(item => {
                if(item.Value.find(u => u.Value === "false") !== undefined)
                    isChecked = false;
            })

            return isChecked;
        }

         /**
         * Sélectionne toutes les lignes du GridPanel
         * @param event
         * @param rows
         * @param page
         */
         private selectRows(event, rows: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }>, page: number, pageSize: number){
            let items: {Key: string, Value: {Key: string, Value: string}[]}[] = [];
            items = this.getItems(rows, page, pageSize);

            items.forEach(item => {
                rows.find(u => u.Key === item.Key).Value.find(u => u.Key === 'Selected').Value = event.toString();
            })

            event = false;
        }

        /**
         * Récupère toutes les valeurs du tableau
         * @param rows 
         * @param page 
         * @param pageSize 
         */
        private getItems(rows: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }>, page: number, pageSize: number){
            let items: {Key: string, Value: {Key: string, Value: string}[]}[] = [];

            rows.forEach(key => {
                let values: {Key: string, Value: string}[] = [];
                key.Value.forEach(value => {
                    values.push({Key: value.Key, Value: value.Value});
                })

                items.push({Key: key.Key, Value: values});
            })

            items = items.splice(pageSize * (page - 1), pageSize);

            return items;
        }

        /**
         * Récupère la class de la ligne
         * @param parameters 
         * @returns
         */
        private getRowClass(parameters: {Key: string, Value: {Key: string, Value: string}[]}){
            if(parameters.Value.find(u => u.Key === 'Selected').Value === 'true')
                return 'b-table-row-selected table-active';
            else return '';
        }

        /**
         * Sélectionne une ligne du GridPanel
         * @param event 
         * @param rows 
         * @param key 
         * @param item 
         */
         private selectRow(event, parameters: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }>, item: string){
            let value: Array<{Key: string, Value: string}> = parameters.find(u => u.Key === item).Value;

            parameters.find(u => u.Key === item).Value.find(x => x.Key === 'Selected').Value = String(!this.isChecked(value));

        }

        /**
         * Vérifie si toutes les lignes sont cochées
         * @param parameters
         * @returns
         */
         private isChecked(parameter: Array<{ Key: string, Value: string }>){
            if(parameter.find(u => u.Key === "Selected").Value === 'false')
                return false;
            else return true;
        }

        /**
         * Sélectionne toutes les lignes du GridPanel
         * @param evt
         * @param parameters
         */
         private selectAll(evt: string, parameters: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }>){
            let event: string = 'false';
            if(evt)
                event = 'true';

            parameters.forEach(u => {
                u.Value.find(x => x.Key === 'Selected').Value = event;
            })
        }

        mounted(){
            this.$emit('child-event', 'mounted');
        }

        updated(){
            this.$emit('child-event', 'updated');
        }
    }
</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>